import { v4 as uuidv4 } from "uuid";
import { formatDate } from "utils/commonUtils";
import { ActionWrapperBox } from "components/Common/common.styled";
import {
  ButtonIcon,
  RoundedIconCloudDownload,
  DeleteActionIcon,
} from "components/Ui/styled";

const renderEmployeeDocumentActions = (
  params,
  handleDownloadStagedDocument,
  handleDeleteStagedDocument
) => {
  return (
    <ActionWrapperBox>
      <ButtonIcon
        onClick={() => handleDownloadStagedDocument(params)}
        data-testid="buttonIcon"
      >
        <RoundedIconCloudDownload />
      </ButtonIcon>
      <ButtonIcon
        onClick={() => handleDeleteStagedDocument(params)}
        data-testid="deleteButtonIcon"
      >
        <DeleteActionIcon />
      </ButtonIcon>
    </ActionWrapperBox>
  );
};

export const stagedEmployeeDocumentsColumns = (
  handleDownloadStagedDocument,
  handleDeleteStagedDocument
) => [
  {
    field: "action",
    headerName: "Action",
    sortable: false,
    disableColumnMenu: true,
    width: 80,
    renderCell: (params) =>
      renderEmployeeDocumentActions(
        params,
        handleDownloadStagedDocument,
        handleDeleteStagedDocument
      ),
  },
  { headerName: "File Name", field: "filename", flex: 1 },
  {
    headerName: "Size",
    field: "size",
    flex: 1,
  },
  { headerName: "Friendly Size", field: "friendlySize", flex: 1 },
  { headerName: "Uploaded At", field: "uploadedAt", flex: 1 },
];

export const getStagedEmployeeDocumentsListData = (
  stagedEmployeeDocumentsData
) => {
  const documents = stagedEmployeeDocumentsData?.documents;
  if (!documents || documents.length === 0) {
    return [];
  }
  return documents.map((item) => ({
    ...item,
    id: uuidv4(),
    filename: item.filename,
    size: item.size,
    friendlySize: item.friendlySize,
    uploadedAt: formatDate(item.uploadedAt),
  }));
};
